module.exports = __webpack_public_path__ + "static/correct-answer-15a6c148e6d55b4b17765cd1a973980b.mp3";